import { UpdateReadSeqParam, UpdateReadSeqResponse } from '@@types/Api/Member';

import { URLS } from '~/constants';
import InterTenantApi from '~/stores/providers/InterTenantApi';

class InterTenantMeApi {
  constructor(private api: InterTenantApi) {}

  updateReadSeq = ({ channelId, readSeq }: UpdateReadSeqParam): Promise<UpdateReadSeqResponse> => {
    return this.api.resultRequester.post(`${URLS.V4_API}/channels/${channelId}/members/me/update-seq`, { readSeq });
  };
}

export default InterTenantMeApi;
